export default __webpack_public_path__ + "static/media/x_close_popup.06e81e04.svg";